// Shared helpers for the weekly appointment calendar (Monday–Friday view).

// Local YYYY-MM-DD (no UTC shift) for a Date.
export function ymd(date) {
  const p = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
}

// Midnight copy of a date (drops time component).
function dayOnly(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

// Monday that begins the week containing `date`.
export function startOfWeek(date) {
  const d = dayOnly(date);
  const dow = d.getDay(); // 0 Sun .. 6 Sat
  const back = dow === 0 ? 6 : dow - 1; // days since Monday
  d.setDate(d.getDate() - back);
  return d;
}

export function addDays(date, n) {
  const d = dayOnly(date);
  d.setDate(d.getDate() + n);
  return d;
}

// The five weekday Dates (Mon..Fri) for a week that starts on `monday`.
export function weekdays(monday) {
  return [0, 1, 2, 3, 4].map((i) => addDays(monday, i));
}

// "Jun 16 – 20" or "Jun 30 – Jul 4" for a Mon..Fri week.
export function formatWeekRange(monday) {
  const fri = addDays(monday, 4);
  const left = monday.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const right = monday.getMonth() === fri.getMonth()
    ? fri.toLocaleDateString('en-US', { day: 'numeric' })
    : fri.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${left} – ${right}, ${fri.getFullYear()}`;
}

// 'past' | 'today' | 'future' for a day string vs. today.
export function dayStatus(dayStr) {
  const today = ymd(new Date());
  if (dayStr < today) return 'past';
  if (dayStr === today) return 'today';
  return 'future';
}

// Group appointments by local day string. Returns { 'YYYY-MM-DD': [appt, ...] }
// with each day's list sorted by time ascending.
export function groupByDay(appointments) {
  const map = {};
  for (const a of appointments) {
    const d = new Date(a.appointment_datetime);
    if (isNaN(d)) continue;
    const key = ymd(d);
    (map[key] = map[key] || []).push(a);
  }
  for (const key of Object.keys(map)) {
    map[key].sort(
      (x, y) => new Date(x.appointment_datetime) - new Date(y.appointment_datetime)
    );
  }
  return map;
}

// "2:30 PM" for an appointment datetime string.
export function formatTime(dtStr) {
  const d = new Date(dtStr);
  if (isNaN(d)) return '';
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

// Short label for a day column header, e.g. "Mon" / "Jun 16".
export function dayName(date) {
  return date.toLocaleDateString('en-US', { weekday: 'short' });
}
export function dayShort(date) {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// Rep display name from a serialized appointment.
export function repLabel(appt) {
  return appt.rep_full_name || appt.rep_username || String(appt.rep);
}
